import { FormsService } from "../../../services/forms/forms.service";
import { DuplicatePromoCodeActionType } from "../types";

export function* duplicatePromoCodeSaga({ payload }: DuplicatePromoCodeActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.duplicatePaymentPromoCode(payload.promoCodeId);

        window.handleChange({ id: "payment.promocodes", value: [...payload.promoList, data] });
    } catch (error) {
        // yield put(Handle Error);
    }
}
